import React, { useState, useEffect } from 'react';
import { colors, API, fmt } from '../utils/theme';
import { PageHeader, StatCard, Table, Th, Td, TrHover, Input, LoadingSpinner } from '../components/UI';
import useSort from '../hooks/useSort';

function EntradasTable({ entradas }) {
  const { sorted, sortKey, sortDir, toggleSort } = useSort(entradas, 'data', 'desc');
  const sortState = { sortKey, sortDir };
  return (
    <Table>
      <thead><tr>
        <Th sortKey="data" sortState={sortState} onSort={toggleSort}>Data</Th>
        <Th sortKey="descricao" sortState={sortState} onSort={toggleSort}>Descrição</Th>
        <Th sortKey="valor" sortState={sortState} onSort={toggleSort}>Valor</Th>
      </tr></thead>
      <tbody>
        {sorted.map((e, i) => (
          <TrHover key={i}>
            <Td>{e.data}</Td>
            <Td>{e.descricao}</Td>
            <Td style={{ color: colors.success, fontWeight: 600 }}>{fmt(e.valor)}</Td>
          </TrHover>
        ))}
      </tbody>
    </Table>
  );
}

function SaidasTable({ saidas }) {
  const { sorted, sortKey, sortDir, toggleSort } = useSort(saidas, 'data', 'desc');
  const sortState = { sortKey, sortDir };
  return (
    <Table>
      <thead><tr>
        <Th sortKey="data" sortState={sortState} onSort={toggleSort}>Data</Th>
        <Th sortKey="descricao" sortState={sortState} onSort={toggleSort}>Descrição</Th>
        <Th sortKey="valor" sortState={sortState} onSort={toggleSort}>Valor</Th>
        <Th sortKey="titular_nome" sortState={sortState} onSort={toggleSort}>Titular</Th>
      </tr></thead>
      <tbody>
        {sorted.map((s, i) => (
          <TrHover key={i}>
            <Td>{s.data}</Td>
            <Td>{s.descricao}</Td>
            <Td style={{ color: colors.danger, fontWeight: 600 }}>{fmt(s.valor)}</Td>
            <Td>{s.titular_nome || '-'}</Td>
          </TrHover>
        ))}
      </tbody>
    </Table>
  );
}

export default function FluxoCaixaPage() {
  const [data, setData] = useState({ entradas: [], saidas: [], resumo: {} });
  const [mes, setMes] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = mes ? `?mes=${mes}` : '';
    fetch(`${API}/dashboard/fluxo-caixa${params}`).then(r => r.json()).then(setData).catch(console.error).finally(() => setLoading(false));
  }, [mes]);

  const r = data.resumo || {};
  const saldo = (r.total_entradas || 0) - (r.total_saidas || 0);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>Fluxo de Caixa</h2>
          <div style={{ fontSize: 13, color: colors.textMuted, marginTop: 4 }}>Entradas e saídas financeiras</div>
        </div>
        <Input type="month" value={mes} onChange={e => setMes(e.target.value)} style={{ width: 200 }} />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <StatCard label="Total Entradas" value={fmt(r.total_entradas)} color={colors.success} />
        <StatCard label="Total Saídas" value={fmt(r.total_saidas)} color={colors.danger} />
        <StatCard label="Saldo" value={fmt(saldo)} color={saldo >= 0 ? colors.success : colors.danger} />
        <StatCard label="Realizado" value={fmt(r.entradas_realizadas || 0)} subtitle={`Saídas: ${fmt(r.saidas_realizadas || 0)}`} />
      </div>

      {loading ? <LoadingSpinner /> : (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 12 }}>Entradas</h3>
            {data.entradas.length === 0 ? (
              <div style={{ background: colors.card, borderRadius: 12, border: `1px solid ${colors.border}`, padding: 40, textAlign: 'center', color: colors.textMuted }}>
                Nenhuma entrada registrada
              </div>
            ) : (
              <EntradasTable entradas={data.entradas} />
            )}
          </div>
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 12 }}>Saídas</h3>
            {data.saidas.length === 0 ? (
              <div style={{ background: colors.card, borderRadius: 12, border: `1px solid ${colors.border}`, padding: 40, textAlign: 'center', color: colors.textMuted }}>
                Nenhuma saída registrada
              </div>
            ) : (
              <SaidasTable saidas={data.saidas} />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
